import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Space, Tag } from 'antd'
import { ActionButton } from 'Components/button'
import { MyTheme } from 'Components/common/Theme'
import { StatusTag } from 'Components/utilities'
import { themeConfig } from 'config'
import React from 'react'
import { CallBackProps, Locale, STATUS, Step } from 'react-joyride'
import styled from 'styled-components'
import { PointConfigChanelText } from './constanst'
const enableProductOnline = themeConfig?.component?.elementOnlineProduct
const locale = {
  skip: 'ปิดการแนะนำ',
  next: 'ต่อไป',
  back: 'กลับ',
  last: 'จบการแนะนำ',
} as Locale
const placement = 'right'
const hideBackButton = false
const showProgress = false
const Title = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`
const TitlePrimary = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const Description = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.back};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Remark = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Bold = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

export const handleJoyrideCallback = (data: CallBackProps, onClose: Function) => {
  const { status } = data
  const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED]

  if (finishedStatuses.includes(status)) {
    onClose()
  }
}

export const TutorialOrderPage = {
  list: {
    enable: false,
    steps: [
      {
        target: '.ttr-status',
        content: (
          <div style={{ textAlign: 'left' }}>
            <p>แท็บ ถูกแบ่งออกตามสถานะของรายการขาย</p>
            <Space direction="vertical" size={'small'}>
              <span>รอการชำระเงิน คือ xxxx</span>
              <span>รายกาารสั่งซื้อใหม่ คือ xxxx</span>
            </Space>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: false,
      },
      {
        target: '.ttr-filter',
        content: 'ส่วนสำหรับกรองข้อมูลรายการสั่งซื้อ',
        locale,
        placement,
        showProgress,
      },
      {
        target: '.search-btn',
        content: 'กดปุ่ม ค้นหา เพื่อค้นหาข้อมูลตามเงื่อนไขที่กรอง',
        locale,
        placement,
        showProgress,
      },
      {
        target: '.ttr-order-0',
        content: 'กดคำสั่งซื้อเพื่อดูรายละเอียด',
        locale,
        placement,
        showProgress,
      },
    ] as Step[],
  },
}

export const TutorialMemberPoint = {
  setting: {
    enable: true,
    steps: [
      {
        target: '.ttr-all',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน การกำหนดให้สินค้าทุกรายการสะสมคะแนน</div>
            <div>
              <StatusTag isPass={true} text={'เปิดใช้งาน'} /> คือ สินค้าในร้านจะได้รับคะแนนตามที่ตั้งค่า
              (ยกเว้นสินค้าที่ถูกกำหนดให้สะสมคะแนนบางรายการ)
            </div>
            <div>
              <StatusTag isPass={false} text={'ปิดใช้งาน'} /> คือ สินค้าทั้งหมดในร้านจะไม่ได้รับคะแนนสะสม
              (ยกเว้นสินค้าที่ถูกกำหนดให้สะสมคะแนนบางรายการ)
            </div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-point-type',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>เลือกรูปแบบการสะสมคะแนน</TitlePrimary>
            <div>
              <Title>สะสมคะแนนจากมูลค่ายอดซื้อสินค้า</Title> คือ เมื่อลูกค้าซื้อสินค้าถึงยอดที่กำหนด
              มูลค่ายอดซื้อทุกๆ x บาท จะได้รับ x คะแนน
            </div>
            <div>
              <Title>สะสมคะแนนจากจำนวนหน่วยสินค้า</Title> คือ เมื่อลูกค้าซื้อสินค้าจำนวนซื้อสินค้าทุกๆ x หน่วย
              จะได้รับ x คะแนน
            </div>
            <Remark>หมายเหตุ : x คือจำนวนตัวเลขที่ร้านค้ากำหนดเอง</Remark>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-point-condition',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>เงื่อนไขการให้คะแนน </TitlePrimary>
            <div>ใส่เงื่อนไขการให้คะแนน ตามรูปแบบที่เลือก</div>
            <div>
              <Title>สะสมคะแนนจากมูลค่ายอดซื้อสินค้า</Title>
            </div>
            <Tag>ตัวอย่าง</Tag>
            <Description>มูลค่ายอดซื้อทุกๆ 100 บาท จำนวนคะแนนที่ได้รับ 1 คะแนน</Description>
            <Description>เมื่อลูกค้าซื้อสินค้าในร้าน 450 บาท ลูกค้าจะได้รับ 4 คะแนน</Description>
            <div>
              <Title>สะสมคะแนนจากจำนวนหน่วยสินค้า</Title>
            </div>
            <Tag>ตัวอย่าง</Tag>
            <Description>มูลค่ายอดซื้อทุกๆ 10 หน่วย จำนวนคะแนนที่ได้รับ 1 คะแนน</Description>
            <Description>เมื่อลูกค้าซื้อสินค้าในร้าน 20 หน่วย ลูกค้าจะได้รับ 2 คะแนน</Description>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-special',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน กำหนดสินค้าบางรายการเพื่อสะสมคะแนน</div>
            <div>
              กรุณา <StatusTag isPass={true} text={'เปิดใช้งาน'} /> หากต้องการให้สินค้าบางรายการในร้าน
              ให้คะแนนที่แตกต่างไปจากสินค้าอื่นๆ ในร้าน เช่น สินค้าอื่นๆ ถูกกำหนดว่าทุกๆ 100 บาทได้รับ 1 คะแนน
              แต่ต้องการกำหนดให้สินค้าบางรายการของร้าน ซื้อ 50 บาทรับ 1 คะแนน
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-product',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>สินค้าที่ร่วมรายการ </TitlePrimary>
            <div>
              เลือกสินค้าที่ต้องการสะสมคะแนนด้วยรูปแบบนี้ โดยสินค้า 1 รายการ
              จะสามารถสะสมคะแนนได้เพียงรูปแบบเดียว
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-add-condition',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>เพิ่มเงื่อนไขการสะสมคะแนน </TitlePrimary>
            <div>ร้านค้าสามารถกำหนดเงื่อนไขการสะสมคะแนนรูปแบบพิเศษได้หลายรูปแบบ</div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-delete-condition',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ลบเงื่อนไขการสะสมคะแนน </TitlePrimary>
            <div>ลบเงื่อนไข หากไม่ต้องการใช้งานรูปแบบนี้อีกต่อไป</div>
            <div>
              หากกดยืนยันการลบ ข้อมูลจะไม่สามารถเอากลับคืนได้ ร้านค้าจะต้องสร้างใหม่หากลบข้อมูลนั้นไปแล้ว
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-channel',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ช่องทางยอดซื้อสินค้าที่จะได้รับคะแนน </TitlePrimary>
            <div>สามารถเลือกได้หลายช่องทาง</div>
            <div>
              <Title>{PointConfigChanelText.POS}</Title> คือ ลูกค้าจะได้รับคะแนนเมื่อซื้อสินค้าผ่านช่องทาง{' '}
              {PointConfigChanelText.POS}
            </div>
            <div>
              <Title>{PointConfigChanelText.SUP}</Title> คือ ลูกค้าจะได้รับคะแนนเมื่อซื้อสินค้าผ่านช่องทาง{' '}
              {PointConfigChanelText.SUP}
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>บันทึกข้อมูล </TitlePrimary>
            <div>
              เมื่อทำการระบุข้อมูลครบถ้วนแล้ว กรุณากดบันทึกข้อมูล
              การสะสมคะแนนจะทำงานตามการตั้งค่าของร้านค้าทันที
            </div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-cancel',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ยกเลิก </TitlePrimary>
            <div>หากต้องการยกเลิกข้อมูลที่เพิ่งแก้ไขไปล่าสุด และดึงข้อมูลที่ถูกบันทึกไว้ล่าสุดมาทดแทน</div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
  memberList: {
    enable: false,
    steps: [
      {
        target: '.ttr-filter',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>ค้นหาข้อมูลสมาชิก ด้วยชื่อลูกค้า หรือเบอร์โทรศัพท์</div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-report',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>คลิกเพื่อดาวน์โหลดรายงานข้อมูลสมาชิก</div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-table',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>
              ข้อมูลของสมาชิกทั้งหมด ประกอบด้วย สมาชิกที่มาจากเครื่องขายหน้าร้าน และสมาชิกจากระบบขายราคาพิเศษ
            </div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
        placement: 'right',
      },
      {
        target: '.ttr-action-btn',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>สามารถจัดการข้อมูลสมาชิกได้ดังนี้ </TitlePrimary>
            <Space wrap>
              <Title>แก้ไขข้อมูล</Title> สามารถแก้ไขข้อมูลสมาชิก และอัพโหลดเอกสารของสมาชิกที่ร้านค้าต้องการได้
            </Space>
            <Space wrap>
              <Title>จัดการคะแนน</Title> สามารถเพิ่ม/ลดคะแนน ให้แก่สมาชิกได้ โดยที่ไม่ต้องมีรายการขาย
            </Space>
            <Space wrap>
              <Title>แลกของรางวัล</Title> สามารถแลกของรางวัลให้แก่สมาชิกได้
            </Space>
            <Space wrap>
              <Title>ประวัติคะแนน</Title> ดูประวัติการสะสมคะแนน และประวัติการแลกของรางวัลของสมาชิก
            </Space>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
        placement: 'right',
      },
    ] as Step[],
  },
}

export const TutorialStockConfig = {
  setting: {
    enable: true,
    steps: [
      {
        target: '.ttr-all',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>
              Toggle switches เปิดการใช้งาน/ปิดการใช้งาน แจ้งเตือนสต๊อกขั้นต่ำของสินค้าทั้งหมดในร้านค้า
            </div>
            <div>
              <StatusTag isPass={true} text={'เปิดใช้งาน'} /> คือ จะแจ้งเตือนที่เมนูสินค้าคงคลัง
              หากสินค้าคงเหลือต่ำกว่าจำนวนขั้นต่ำที่กำหนด
            </div>
            <div>
              <StatusTag isPass={false} text={'ปิดใช้งาน'} /> คือ
              เมื่อสินค้าใกล้หมดจะไม่แจ้งเตือนใดๆที่หน้าสินค้าคงคลัง
            </div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-qty',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>
              <Title>จำนวนจำนวนขั้นต่ำของสต๊อก</Title> คือ จะแจ้งเตือนที่เมนูสินค้าคงคลัง
              หากสินค้าคงเหลือน้อยกว่า x หน่วย
            </div>
            <Remark>หมายเหตุ : x คือจำนวนตัวเลขที่ร้านค้ากำหนดเอง</Remark>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-special',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน แจ้งเตือนสต๊อกขั้นต่ำแบบกำหนดสินค้าเอง</div>
            <div>
              กรุณา <StatusTag isPass={true} text={'เปิดใช้งาน'} />{' '}
              หากต้องการเปิดการแจ้งเตือนสต๊อกขั้นต่ำของสินค้า ที่ระบุจำนวนขั้นต่ำต่างจากสินค้าอื่น
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-product',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>สินค้าที่ร่วมรายการ </TitlePrimary>
            <div>เลือกสินค้าที่ต้องการแจ้งเตือนเมื่อสินค้าคงเหลือน้อยกว่าจำนวนที่ระบุนี้</div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-add-condition',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>เพิ่มเงื่อนไขการแจ้งเตือน </TitlePrimary>
            <div>ร้านค้าสามารถเพิ่มเงื่อนไขการแจ้งเตือนได้หลายรูปแบบ</div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-delete-condition',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ลบเงื่อนไขการแจ้งเตือน </TitlePrimary>
            <div>ลบเงื่อนไข หากไม่ต้องการใช้งานรูปแบบนี้อีกต่อไป</div>
            <div>
              หากกดยืนยันการลบ ข้อมูลจะไม่สามารถเอากลับคืนได้ ร้านค้าจะต้องสร้างใหม่หากลบข้อมูลนั้นไปแล้ว
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>บันทึกข้อมูล </TitlePrimary>
            <div>เมื่อทำการระบุข้อมูลครบถ้วนแล้ว กรุณากดบันทึกข้อมูล จะแจ้งเตือนที่เมนูสินค้าคงคลัง</div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-cancel',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ยกเลิก </TitlePrimary>
            <div>หากต้องการยกเลิกข้อมูลที่เพิ่งแก้ไขไปล่าสุด และดึงข้อมูลที่ถูกบันทึกไว้ล่าสุดมาทดแทน</div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
}

export const TutorialPaymentConfig = {
  setting: {
    enable: true,
    steps: [
      {
        target: '.ttr-transfer',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน ชำระเงินแบบเงินโอน </div>
            <div>
              <StatusTag isPass={true} text={'เปิดใช้งาน'} /> คือ
              สามารถชำระเงินได้โดยการโอนเงินเข้าบัญชีของร้านค้าโดยตรง
            </div>
            <div>
              <StatusTag isPass={false} text={'ปิดใช้งาน'} /> คือ
              ไม่สามารถชำระเงินได้โดยการโอนเงินเข้าบัญชีของร้านค้าโดยตรง
            </div>
          </Space>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-qr',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน ชำระเงินแบบสแกนผ่าน QR Code</div>
            <div>
              <StatusTag isPass={true} text={'เปิดใช้งาน'} /> คือ ระบบจะแสดง QR Code
              ที่หน้าจอเครื่องขายหน้าร้าน (Terminal) ลูกค้าสามารถสแกน QR code เพื่อชำระเงินได้เลย
            </div>
            <div>
              <StatusTag isPass={false} text={'ปิดใช้งาน'} /> คือ ไม่สามารถชำระเงินได้โดยการสแกน QR Code
            </div>
            <TitlePrimary>เลือกประเภทของร้านค้า</TitlePrimary>
            <div>
              <Title>บุคคลธรรมดา</Title> ระบุหมายเลขพร้อมเพย์ (เบอร์โทรศัพท์ หรือหมายเลขบัตรประชาชน)
              และชื่อบัญชี ของบัญชีที่ต้องการรับเงิน
            </div>
            <div>
              <Title>นิติบุคคล</Title> สำหรับบริษัท ร้านสามารถขอเปิดใช้งาน QR Payment ได้กับธนาคารโดยตรง
              เพื่อขอข้อมูลในการเปิดใช้งาน และนำมาระบุในระบบตามข้อมูลดังนี้
              <br /> - เลขผู้เสียภาษีของบริษัท <br />
              - หมายเลขบัญชีบริษัท <br />
              - ชื่อบัญชี ธนาคาร <br />
              ข้อมูลที่ได้หลังจากขอเปิดใช้งานกับธนาคาร
              <br /> - Biller ID
              <br />- หมายเลขอ้างอิง 1 (Ref 1)
              <br /> - หมายเลขอ้างอิง 2 (Ref 2)
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-credit-term',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <div>Toggle switches เปิดการใช้งาน/ปิดการใช้งาน ชำระเงินแบบเครดิตเทอม (Credit Term)</div>
            <div>
              <StatusTag isPass={true} text={'เปิดใช้งาน'} /> คือ สามารถชำระเงินได้โดยการชำระแบบเครดิตเทอม
            </div>
            <div>
              <StatusTag isPass={false} text={'ปิดใช้งาน'} /> คือ ไม่สามารถชำระเงินได้โดยการชำระแบบเครดิตเทอม
            </div>
            <div>
              <Title>เครดิตเทอม (Credit Term)</Title> คือ การที่ผู้ประกอบการตกลงกับร้านค้าขายวัตถุดิบ
              หรือซัพพลายเออร์ เพื่อขอนำวัตถุดิบเหล่านั้นไปใช้ก่อนแล้วค่อยนำเงินมาจ่ายทีหลัง
              รายการขายที่ชำระแบบเครดิตเทอม ร้านค้าจะต้องทำการเก็บเงินลูกค้าเองในภายหลัง
            </div>
          </Space>
        ),
        locale,
        placement: 'auto',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>บันทึกข้อมูล </TitlePrimary>
            <div>
              เมื่อทำการระบุข้อมูลครบถ้วนแล้ว กรุณากดบันทึกข้อมูล เครื่องขายหน้าร้าน
              จะแสดงช่องทางการชำระเงินตามที่ร้านค้าตั้งค่า
            </div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-cancel',
        content: (
          <Space direction="vertical" style={{ textAlign: 'left' }}>
            <TitlePrimary>ยกเลิก </TitlePrimary>
            <div>หากต้องการยกเลิกข้อมูลที่เพิ่งแก้ไขไปล่าสุด และดึงข้อมูลที่ถูกบันทึกไว้ล่าสุดมาทดแทน</div>
          </Space>
        ),
        locale,
        placement: 'top',
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
}

export const TutoriaProductPage = {
  list: {
    enable: false,
    steps: [
      {
        target: '.ttr-add',
        content: (
          <div style={{ textAlign: 'left' }}>
            <div>
              <Bold>เพิ่มสินค้า </Bold> คือ การเพิ่มสินค้าใหม่ ด้วยการกรอกข้อมูลตามฟอร์มที่ละรายการสินค้า
            </div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-import',
        content: (
          <div style={{ textAlign: 'left' }}>
            <div>
              <Bold>นำเข้าสินค้าจากไฟล์ </Bold> คือการนำข้อมูลสินค้ากรอกลงฟอร์มในไฟล์ Excel
              แล้วอัพโหลดเข้าระบบ สามารถระบุรายการสินค้าได้หลายรายการในไฟล์เดียว
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-filter',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการค้นหาข้อมูลสินค้า </Bold> เพื่อให้สามารถเจอสินค้าที่ต้องการได้ง่ายขึ้น
            โดยสามารถค้นหาสินค้าได้จาก
            <div>- ค้นหาชื่อ หรือ รหัสสินค้า</div>
            <div>
              - ค้นหาชื่อหมวดหมู่สินค้า : สามารถค้นหาได้ด้วยการพิมพ์ข้อความ หรือ เลือกจากกลุ่มสินค้าได้
              โดยหมวดหมู่จะแบ่งเป็น กลุ่มสินค้า/หมวดหมู่หลัก/หมวดหมู่ย่อย{' '}
            </div>
            <div>- สถานะสินค้า : ค้นหาด้วยการเลือกสถานะสินค้า (เปิดใช้งาน/ปิดใช้งาน)</div>
            <div>- สถานะคำขอแก้ไข</div>
            <div>- ช่องทางการจัดส่ง : ค้นหาด้วยประเภทการจัดส่งที่สินค้านั้นรองรับ</div>
            <div>- ประเภทสินค้า : ประเภทสินค้ามี 2 ประเภท คือ สินค้ามีส่วนประกอบ/ สินค้าไม่มีส่วนประกอบ</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-datas',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแสดงข้อมูลสินค้า</Bold> ประกอบด้วย
            <div>- รูปภาพสินค้า</div>
            <div>- รหัสสินค้า</div>
            <div>
              - ชื่อสินค้า : โดยสินค้าประเภท มีส่วนประกอบ
              จะแสดงข้อความว่าสินค้ามีส่วนประกอบอยู่ด้านล่างของชื่อ{' '}
              <Title>&nbsp;&nbsp;สินค้ามีส่วนประกอบ</Title> &nbsp;&nbsp;คือ สินค้าที่นำสินค้าหลายๆ SKU
              มาประกอบขายเป็นชุดหรือเซ็ต โดยสต๊อกของสินค้า จะคำนวนจากสต๊อกของสินค้าส่วนประกอบ
            </div>
            <div>- ราคาสินค้า</div>
            <div>
              - สต๊อก : จำนวนคงเหลือของสินค้า หากสินค้าคงเหลือน้อยกว่า 10 รายการ จะสแดงตัวหนังสือสีแดง
            </div>
            <div>- หมวดหมู่สินค้า : โดยหมวดหมู่จะแบ่งเป็น กลุ่มสินค้า/หมวดหมู่หลัก/หมวดหมู่ย่อย</div>
            <div>- สถานะสินค้า</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-status',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>สถานะสินค้า </Bold>
            <div>
              สามารถ Toggle เพื่อเปิดใช้งาน/ปิดใช้งานสินค้าได้ หากปิดใช้งาน สินค้าจะไม่ถูกแสดงในหน้าขายสินค้า{' '}
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-action',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>สามารถแก้ไขข้อมูลสินค้า หรีอลบรายการสินค้า </Bold>
            <div>
              หากคลิกที่ปุ่ม{' '}
              <ActionButton text="" icon={<EditOutlined />} label="แก้ไข" action="edit" onClick={() => {}} />{' '}
              จะสามารถ
              <div>- แก้ไขข้อมูลสินค้า</div>
              <div>- จัดการส่วนประกอบสินค้า (สำหรับสินค้าประเภทมีส่วนประกอบ)</div>
              <div>- จัดการราคาสินค้าโดยไม่ผ่านการอนุมัติ</div>
            </div>
            <div>
              {' '}
              คลิกที่ปุ่ม{' '}
              <ActionButton
                text=""
                icon={<DeleteOutlined />}
                label="ลบ"
                action="deleted"
                onClick={() => {}}
              />{' '}
              เพื่อลบรายการสินค้า
              <div>หากลบแล้ว ข้อมูลสินค้าจะถูกลบและหายออกไปจากหน้ารายการสินค้า</div>
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-pagination',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแบ่งหน้ารายการสินค้า </Bold>
            <div>
              - สามารถเปลี่ยนจำนวนรายการสินค้าที่ต้องการแสดงผลต่อ 1 หน้า ได้ที่การเลือกจำนวนตัวเลขฝั่งซ้ายมือ
            </div>
            <div>- สามารถเลือกเลขหน้า เพื่อดูข้อมูลสินค้าในหน้าต่อๆไปได้</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
  detail: {
    enable: false,
    steps: [
      {
        target: '.ttr-upload-img',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รูปภาพสินค้า </Bold>
            <div>
              ระบุรูปภาพสินค้าอย่างน้อย 1 รูป ขนาดไฟล์รูปสินค้าที่อัปโหลดต้องมีขนาด 40KB - 10.24 MB (.png
              .jpeg)
            </div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-product-info',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการระบุรายละเอียดสินค้า</Bold> ประกอบด้วยข้อมูลที่จำเป็นต้องระบุ ดังต่อไปนี้
            <div>- ชื่อสินค้า*</div>
            <div>- รหัสสินค้า*</div>
            <div>- หมวดหมู่สินค้า*</div>
            <div>- ยี่ห้อ*</div>
            <div>- หน่วยสินค้า*</div>
            <div>
              - ประเภทสินค้า* : สามารถเลือกประเภทได้ตอนสร้างและไม่สามารถแก้ไขได้
              <Title>&nbsp;&nbsp;สินค้าไม่มีส่วนประกอบ</Title> &nbsp;&nbsp;คือ สินค้าทั่วไป
              ที่ไม่ได้เกิดจากการนำสินค้าอื่นมาประกอบกันเพื่อขาย
              <Title>&nbsp;&nbsp;สินค้ามีส่วนประกอบ</Title> &nbsp;&nbsp;คือ สินค้าที่นำสินค้าหลายๆ SKU
              มาประกอบขายเป็นชุดหรือเซ็ต โดยสต๊อกของสินค้า จะคำนวนจากสต๊อกของสินค้าส่วนประกอบ
            </div>
            <div>- รายละเอียดสินค้า* : เพื่ออธิบายข้อมูลเพิ่มเติมของสินค้า</div>
            <div>
              - ข้อมูลอื่นๆ ที่ไม่จำเป็นระบุก็ได้ คือ วิธีการใช้งาน, การบำรุงรักษาและข้อควรระวัง และ
              คุณสมบัติสินค้า
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
        placement: 'top',
      },
      {
        target: '.ttr-product-option',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ตัวเลือกสินค้า</Bold>
            <div>
              - ระบุตัวเลือกของสินค้าอย่างน้อย 1 ตัวเลือก โดยการกดที่ปุ่ม &quot;เพิ่มตัวเลือกสินค้า&quot;
              เพื่อระบุข้อมูลราคาของสินค้า
            </div>
            <div>
              - หากสินค้าชนิดเดียวกัน แต่ขนาด/สี/ไซต์/คุณสมบัติอื่นต่างกัน สามารถเพิ่มตัวเลือกสินค้าได้มากกว่า
              1 ตัวเลือก
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-delivery',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ช่องทางการจัดส่งสินค้าที่รองรับ (สำหรับขายออนไลน์)</Bold>
            <div>- ส่งฟรี คือ ร้านค้าจัดส่งให้ลูกค้า</div>
            <div>- รับสินค้าหน้าร้าน</div>
            <div>- ร้านค้าจัดส่งเอง ร้านค้าสามารถกำหนดค่าขนส่งของร้านเองได้</div>
            <div>- ขนส่งสาธารณะ : ปัจจุบันขายออนไลน์ รองรับการขนส่งผ่าน BEST Express</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-setting',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ตั้งค่าสินค้า</Bold>
            <div>- การรับประกันสินค้า : หากสินค้ามีการรับประกัน ต้องระบุระยะเวลารับประกัน</div>
            <div>- การรับคืนสินค้า : หากสินค้ามีการรับคืน ต้องระบุระยะเวลาในการรับคืนสินค้า</div>
            {enableProductOnline && <div>- สถานะสินค้าบนออนไลน์ : สำหรับเปิด/ปิดการใช้งานขายออนไลน์</div>}
            <div>- สถานะสินค้าบน Terminal : สำหรับเปิด/ปิดการใช้งานขายบนระบบขายหน้าร้าน </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนการบันทึกข้อมูล</Bold>
            <div>บันทึกข้อมูล เมื่อตรวจสอบความถูกต้องของข้อมูลสินค้าเรียบร้อยแล้ว</div>
            <div>- สำหรับสินค้าที่ไม่ได้เปิดใช้งานบนออนไลน์ข้อมูลจะถูกเปลี่ยนแปลงทันที</div>
            {enableProductOnline && (
              <div>
                - สำหรับสินค้าที่เปิดใช้งานบนออนไลน์ ต้องรอแอดมินทำการอนุมัติ (ระหว่างรออนุมัติ
                ยังสามารถแก้ไขข้อมูลได้)
              </div>
            )}
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
  productOptions: {
    enable: false,
    steps: [
      {
        target: '.ttr-productoption-img',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รูปภาพสินค้า </Bold>
            <div>เลือกรูปภาพสำหรับตัวเลือกสินค้า</div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-productoption-info',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ข้อมูลตัวเลือกสินค้า</Bold> ประกอบด้วยข้อมูลดังต่อไปนี้
            <div>
              - ชื่อตัวเลือกสินค้า* : หากสินค้ามี 1 ตัวเลือก จะดึงชื่อสินค้าเป็นชื่อเริ่มต้นให้
              ร้านค้าสามารถแก้ไขเองได้
            </div>
            <div>
              - Barcode : สามารถกำหนด Barcode สินค้าได้สำหรับใช้เครื่องสแกนเนอร์ โดยตัวเลข Barcode
              รองรับชุดตัวอักษร 128 ASCII (ไม่รองรับภาษาไทย)
            </div>
            <div>- น้ำหนัก* : ระบุน้ำหนักสินค้าใช้สำหรับคำนวนค่าจัดส่ง</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-productoption-price',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ข้อมูลราคาและสต๊อกสินค้า</Bold> ประกอบด้วยข้อมูลดังต่อไปนี้
            <div>
              - สต๊อก : สต๊อกสินค้าถูกกำหนดจากการออกใบสั่งซื้อและรับสินค้าเข้าคลัง
              จะไม่สามารถทำการแก้ไขจำนวนได้
              <div>
                &nbsp;&nbsp;<Bold>การเพิ่มสต๊อกสินค้า</Bold>{' '}
                หากต้องการเพิ่มสต๊อกสินค้าต้องทำการจัดซื้อและรับสินค้าเข้าคลัง(เมนูระบบจัดซื้อ)
              </div>
              <div>
                &nbsp;&nbsp;<Bold>การลดจำนวนสต๊อก</Bold> หากต้องการลดจำนวนสต๊อก
                ต้องทำการปรับสินค้าออกจากคลังที่(เมนูสินค้าคงคลัง &gt; ปรับจำนวนสินค้าคงเหลือในคลัง )
              </div>
            </div>
            {enableProductOnline && (
              <div>
                - เปอร์เซ็นต์ขายบนสต๊อกออนไลน์ (%) : หากสินค้านี้เปิดสถานะการใช้งานออนไลน์
                จำนวนสต๊อกสินค้าจะถูกแบ่งเฉลี่ยตาม % ที่กำหนด ระหว่างขายหน้าร้านและขายออนไลน์ &nbsp;&nbsp;
                <div>
                  &nbsp;&nbsp;<Bold>ตัวอย่าง</Bold> สต๊อกสินค้ามีจำนวน 100 หน่วย กำหนดขายออนไลน์ 10%
                  หมายความว่า สินค้าจะพร้อมจำหน่ายบนออนไลน์ได้ 10 หน่วย และขายหน้าร้าน 90 หน่วย
                  <div>
                    แต่สต๊อกสินค้าออนไลน์จะถูกเกลี่ยใหม่ตาม % ทุกครั้ง เมื่อจำนวนสต๊อกมีการเปลี่ยนแปลง
                  </div>
                </div>
              </div>
            )}
            {enableProductOnline && <div>- ราคาขายออนไลน์* : ราคาที่แสดงบนเว็ป/แอปพลิเคชัน Baandy</div>}
            <div>- ราคาขายหน้าร้าน* : ราคาขายที่แสดงบนระบบขายหน้าร้าน</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-productoption-price-special',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ราคาเพิ่มเติม ใช้สำหรับระบบขายราคาพิเศษ</Bold> (เมนูระบบขายราคาพิเศษ)
            <div>- ราคา A, ราคา B , ราคา C : ร้านค้าสามารถกำหนดรูปแบบของราคาสินค้าเองได้ </div>
            <div>- เมื่อทำการออกใบเสนอราคา จะสามารถเลือกได้ว่าจะขายราคาใดให้กับลูกค้า</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-productoption-status',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>สถานะสินค้า</Bold>
            <div>- สามารถเปิด/ปิดการแสดงตัวเลือกสินค้าได้ </div>
            <div>- แต่สินค้าต้องมีอย่างน้อย 1 ตัวเลือกที่เปิดใช้งาน</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-productoptions-save',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนการบันทึกข้อมูล</Bold>
            <div>บันทึกข้อมูล เมื่อตรวจสอบความถูกต้องของข้อมูลตัวสินค้าเรียบร้อยแล้ว</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
}

export const TutorialPurchasePage = {
  list: {
    enable: false,
    steps: [
      {
        target: '.ttr-add',
        content: (
          <div style={{ textAlign: 'left' }}>
            <div>
              <Bold> ออกใบสั่งซื้อ </Bold> คือ การสร้างใบสั่งซื้อสินค้าใหม่ของร้านค้า
              ส่งให้กับผู้ขายเพื่อสั่งซื้อสินค้า และรับสินค้าเข้าคลังสำหรับจำหน่ายต่อไป
            </div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-status',
        content: (
          <div style={{ textAlign: 'left' }}>
            <div>
              <Bold>สถานะของใบสั่งซื้อ </Bold> โดยแบ่งแถบตามสถานะดังนี้
            </div>
            <div>
              <Bold>แบบร่าง </Bold> สถานะใบสั่งซื้อที่ออกแบบร่างไว้
              ร้านค้ายังสามารถแก้ไขข้อมูล/ลบใบสั่งซื้อได้
            </div>
            <div>
              <Bold>รอรับสินค้า </Bold>{' '}
              สถานะใบสั่งซื้อที่ร้านค้ายืนยันการสร้างแล้วส่งข้อมูลการสั่งซื้อให้กับผู้ขาย(supplier) แล้ว
              ร้านค้าจะไม่สามารถแก้ไขข้อมูลใบสั่งซื้อได้ แต่สามารถยกเลิกใบสั่งซื้อได้ หรือกดรับสินค้าเข้าคลัง
              เมื่อผู้ขาย(supplier) ทำการจัดส่งสินค้าให้กับร้านค้าสำเร็จ
            </div>
            <div>
              <Bold>รับแล้วบางส่วน </Bold> กรณีที่ร้านค้าได้รับสินค้าจากผู้ขาย(supplier) แล้ว
              แต่ยังไม่ครบตามจำนวนที่สั่งซื้อ สถานะของใบสั่งซื้อจะถูกเปลี่ยนจาก รอรับสินค้า -&gt;
              รับแล้วบางส่วน หากผู้ขาย(supplier) มีการจัดส่งสินค้ามาเพิ่มเติม ร้านค้าสามารถกดจากใบสั่งซื้อเดิม
              เพื่อกดรับสินค้าเข้าคลังเพิ่มเติมได้
            </div>
            <div>
              <Bold>สำเร็จ </Bold> คือสถานะของใบสั่งซื้อ ที่มีการสั่งซื้อแล้วทำการรับสินค้าเข้าคลังครบทุกจำนวน
              สถานะใบสั่งซื้อจะถูกเปลี่ยนเป็นสำเร็จโดยอัตโนมัติ
            </div>
            <div>
              <Bold>สำเร็จมีเงื่อนไข </Bold> คือการที่ร้านค้าออกใบสั่งซื้อ แต่ผู้ขาย(supplier)
              จัดส่งของให้ไม่ครบตามจำนวนในใบสั่งซื้อ หากร้านค้าไม่ต้องการที่จะรอรับสินค้าจากผู้ขายแล้ว
              ร้านค้าสามารถกดเปลี่ยนสถานะเป็น สำเร็จมีเงื่อนไข ระบบจะทำการออกใบจ่ายหนี้
              เฉพาะจำนวนรายการที่ร้านค้าได้รับจริงเท่านั้น
            </div>
            <div>
              <Bold>ยกเลิก </Bold> คือสถานะใบสั่งซื้อที่ถูกยกเลิกโดยร้านค้า
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-filter',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการค้นหาข้อมูลใบสั่งซื้อ </Bold> เพื่อให้สามารถเจอใบสั่งซื่อที่ต้องการได้ง่ายขึ้น
            โดยสามารถค้นหาได้จาก
            <div>- ค้นหาเลขที่ใบสั่งซื้อหรือ ชื่อ Supplier</div>
            <div>- ค้นหาจากวันที่ออกใบสั่งซื้อ</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-datas',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแสดงข้อมูลสินค้า</Bold> ประกอบด้วย
            <div>
              เลขที่ใบสั่งซื้อ, ชื่อ Supplier, จำนวน/รายการสินค้า ที่สั่งซื้อ, ราคารวมของใบสั่งซื้อ,
              วันที่สั่งซื้อ คือวันที่เลือกตอนออกใบสั่งซื้อ, สถานะใบสั่งซื้อ และวันที่สร้างใบสั่งซื้อ{' '}
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-no',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>เลขที่ใบสั่งซื้อ </Bold> กดที่เลขที่ใบสั่งซื้อ เพื่อดูรายละเอียดใบสั่งซื้อ
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-action',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>สถานะแบบร่าง </Bold> สามารถแก้ไขข้อมูลใบสั่งซื้อ หรือลบใบสั่งซื้อได้
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-pagination',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแบ่งหน้ารายการสินค้า </Bold>
            <div>
              - สามารถเปลี่ยนจำนวนรายการสินค้าที่ต้องการแสดงผลต่อ 1 หน้า ได้ที่การเลือกจำนวนตัวเลขฝั่งซ้ายมือ
            </div>
            <div>- สามารถเลือกเลขหน้า เพื่อดูข้อมูลสินค้าในหน้าต่อๆไปได้</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
  detail: {
    enable: false,
    steps: [
      {
        target: '.ttr-form',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ระบุข้อมูลใบสั่งซื้อ </Bold> ประกอบด้วย
            <div>
              <Bold>เลขที่ใบสั่งซื้อ </Bold> ร้านค้าไม่ต้องระบุเอง
              ระบบจะสร้างเลขที่ใบสั่งซื้อให้อัตโนมัติหลังการบันทึกข้อมูลครั้งแรก
            </div>
            <div>
              <Bold>วันที่สั่งซื้อ </Bold> คือวันที่ต้องการระบุเป็นวันที่สั่งของไปยังผู้ขาย (supplier)
              โดยจะใส่ค่าเริ่มต้นให้เป็นวันที่ปัจจุบัน ร้านค้าสามารถแก้ไขเองได้
            </div>
            <div>
              <Bold>วันที่จัดส่ง </Bold> คือวันที่ต้องการให้ผู้ขาย (supplier) จัดส่งสินค้า
            </div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-supplier',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>เลือก หรือ บริษัท/Supplier</Bold> กรณียังไม่มีข้อมูล ต้องไปสร้างข้อมูล บริษัท/Supplier
            ที่เมนู ระบบจัดซื้อ &gt; บริษัท/Supplier &gt; เพิ่มข้อมูลบริษัท
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
        placement: 'top',
      },
      {
        target: '.ttr-product',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รายการสินค้าที่ต้องการสั่งซื้อ</Bold>
            <div>- กดที่ปุ่ม +เพิ่มสินค้า เพื่อเลือกรายการสินค้าที่ต้องการสั่งซื้อ</div>
            <div>
              - รายการสินค้าที่เลือกจะแสดงในตารางนี้ ร้านค้าต้องระบุ จำนวน และราคาต้นทุนต่อหน่วย ที่ซื้อจาก
              Supplier
            </div>
            <div>&nbsp;(หากระบุต้นทุนต่อหน่วยไม่ถูกต้อง จะส่งผลให้การคำนวนกำไรจากการขายไม่ถูกต้อง)</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-creater',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ระบุชื่อผู้ออกใบสั่งซื้อ</Bold>
            <div>ชื่อนี้จะถูกแสดงในใบสั่งซื้อที่พิมพ์ส่งไปยัง Supplier ด้วย</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-remark',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ระบุหมายเหตุ (ถ้ามี)</Bold>
            <div>
              เช่น หมายเหตุที่ต้องการโน๊ตให้ Supplier โดยหมายเหตุถูกจะแสดงในใบสั่งซื้อที่พิมพ์ส่งไปยัง
              Supplier ด้วย
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-draft',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>บันทึกแบบร่าง</Bold>
            <div>หากยังระบุข้อมูลไม่ครบถ้วน สามารถบันทึกแบบร่างไว้ก่อนได้</div>
            <div>สถานะใบสั่งซื้อจะถูกบันทึกเป็น สถานะ : แบบร่าง </div>
            <div>ร้านค้าจะสามารถกลับมาแก้ไขข้อมูล หรือลบข้อมูลใบสั่งซื้อได้</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ยืนยันการสร้าง</Bold>
            <div>หากระบุข้อมูลครบถ้วนแล้ว ร้านค้าสามารถกดยืนยันการสร้างได้เลย</div>
            <div>สถานะใบสั่งซื้อจะถูกบันทึกเป็น สถานะ : รอรับสินค้า </div>
            <div>ร้านค้าจะไม่สามารถกลับมาแก้ไขข้อมูลในใบสั่งซื้อได้</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-history',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ประวัติการแก้ไขใบสั่งซื้อ</Bold>
            <div>สามารถดูประวัติการแก้ไขใบสั่งซื้อได้ ว่าใครเป็นผู้แก้ไขใบสั่งซื้อ และวัน/เวลาที่แก้ไข</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-print',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>พิมพ์ใบสั่งซื้อ</Bold>
            <div>
              หลังจากบันทึกข้อมูลสำเร็จ ร้านค้าสามารถพิมพ์ใบสั่งซื้อได้ เพื่อส่งใบสั่งซื้อนี้ไปให้ Supplier
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
  stock: {
    enable: false,
    steps: [
      {
        target: '.ttr-info-sup',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รายละเอียดใบสั่งซื้อ </Bold> ประกอบด้วย
            <div>- เลขที่ใบสั่งซื้อ</div>
            <div>- วันที่สั่งซื้อ</div>
            <div>- บริษัท/Supplier</div>
            <div>- ที่อยู่บริษัท/Supplier</div>
            <div>- เบอร์โทรศัพท์บริษัท/Supplier</div>
            <div>- สถานะใบสั่งซื้อ</div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-info-merchant',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รายละเอียดร้านค้า</Bold> ประกอบด้วย
            <div>- ชื่อร้านค้า</div>
            <div>- ที่อยู่ร้านค้า</div>
            <div>- เบอร์โทรศัพท์ร้านค้า</div>
            <div>- ชื่อผู้ออกใบสั่งซื้อ</div>
            <div>- หมายเหตุ</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
        placement: 'top',
      },
      {
        target: '.ttr-product',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold> รายการรอรับสินค้าเข้าคลัง</Bold> คือ รายการสินค้าตามใบสั่งซื้อ ที่รอรับเข้าคลัง
            <div>- โดยจะแสดง รายละเอียดของสินค้า, จำนวนที่สั่งซื้อ และจำนวนค้างรับ</div>
            <div>- หากรับครบจำนวนแล้ว จำนวนค้างรับ = 0 จะไม่สามารถกดรับเข้าคลังได้</div>
            <div>- หากสินค้าที่ยังรับไม่ครบจำนวนแล้ว จะแสดงปุ่ม รับเข้า เพื่อให้กดรับเข้าสินค้า</div>
            <div>
              &nbsp; กรณีกดรับเข้า ร้านค้าต้องระบุจำนวนรับเข้า โดยระบบจะใส่ค่าเริ่มต้นให้คือครบเต็มจำนวน
              หากร้านค้าได้รับไม่ครบเต็มจำนวน จะต้องแก้ไขจำนวนรับเข้าด้วย
            </div>
            <div>
              &nbsp; กรณีมีต้นทุนแฝง กรุณาระบุที่ฟอร์มรับสินค้าเข้าคลัง
              เนื่องจากต้นทุนแฝงจะถูกนำไปคำนวนต้นทุนสินค้า
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-pickup-all',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>รับเข้าคลังทั้งหมด</Bold>
            <div>
              เพื่อความสะดวกต่อผู้ใช้งาน สามารถกดปุ่มรับเข้าคลังทั้งหมด
              เพื่อรับสินค้าทั้งหมดเข้าคลังแบบเต็มจำนวนด้วยการคลิกเพียงครั้งเดียว
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-hidden-cost',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ระบุต้นทุนแฝง (ถ้ามี)</Bold> หากร้านค้ามีต้นทุนแฝง เช่น ค่าจัดส่ง เป็นต้น การระบุต้นทุนแฝงมี
            2 ประเภทได้แก่
            <div>
              - ต้นทุนแฝงเฉลี่ย คือ ร้านค้าระบุต้นทุนแฝงทั้งหมด ของการจัดส่งสินค้า ณ รอบนั้นๆ
              แล้วระบบจะทำการคำนวนต้นทุนแฝงเฉลี่ย ต่อรายการสินค้าให้
            </div>
            <div>
              - ต้นทุนแฝงต่อรายการสินค้า (SKU) คือ ร้านค้าระบุต้นทุนแฝงต่อรายการสินค้า (SKU) มาเลย
              โดยที่ไม่ต้องการให้ระบบนำไปคำนวนให้
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-product-pickup',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold> รายการรับเข้าคลัง</Bold> คือ รายการสินค้าที่ถูกเลือกรับเข้าคลัง
            <div>- โดยจะแสดง รายละเอียดของสินค้า, จำนวนที่รับเข้าและจำนวนคงเหลือค้างรับ</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-save',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ยืนยันรับเข้าคลัง</Bold>
            <div>ตรวจสอบความถูกต้องของรายการสินค้าที่ต้องการรับเข้า แล้วกดปุ่มยืนยันรับเข้าคลัง</div>
            <div>หากยืนยันรับเข้าคลัง สต๊อคสินค้าจะถูกเพิ่มตามจำนวนรับเข้าทันที</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
}

export const TutorialGrnPage = {
  list: {
    enable: false,
    steps: [
      {
        target: '.ttr-status',
        content: (
          <div style={{ textAlign: 'left' }}>
            <div>
              <Bold>สถานะของรายการจ่ายหนี้ </Bold> โดยแบ่งแถบตามสถานะดังนี้
            </div>
            <div>
              <Bold>ใกล้ถึงกำหนดชำระ </Bold> จะแสดงรายการชำระหนี้ที่ใกล้ถึงกำหนดชำระอีก 3 วันข้างหน้า
              และรายการที่เกินกำหนดชำระ
            </div>
            <div>
              <Bold>รอชำระหนี้ </Bold> คือรายการจัดซื้อ ที่รับเข้าคลังสำเร็จ
              แต่ร้านค้ายังไม่ได้ชำระเงินให้กับผู้ขาย (Supplier) (รวมถึงรายการที่ใกล้ถึงกำหนดชำระด้วย)
            </div>
            <div>
              <Bold>ชำระแล้วบางส่วน </Bold> คือรายการจ่ายหนี้ที่มีการชำระแล้ว แต่ยังชำระไม่เต็มจำนวน
            </div>
            <div>
              <Bold>ชำระสำเร็จ </Bold> คือรายการจ่ายหนี้ที่มีการชำระเงินให้กับผู้ขาย(Supplier) ครบแล้ว
            </div>
          </div>
        ),
        locale,
        showProgress,
        disableBeacon: true,
        hideBackButton,
      },
      {
        target: '.ttr-filter',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการค้นหารายการจ่ายหนี้ </Bold> เพื่อให้สามารถเจอใบสั่งซื่อที่ต้องการได้ง่ายขึ้น
            โดยสามารถค้นหาได้จาก
            <div>- ค้นหาเลขที่ใบสั่งซื้อหรือ เลขที่ใบจ่ายหนี้ (GRN)</div>
            <div>- ค้นหาจาก Supplier</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-pay-all',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>จ่ายหนี้หลายรายการ </Bold> เพื่อให้ร้านค้าสามารถเลือกชำระหนี้ได้หลายๆรายการพร้อมกัน
            (สามารถเลือกชำระได้ทีละ Supplier)
            <div>- เมื่อชำระแล้ว สถานะของรายการจ่ายหนี้ที่ถูกเลือก จะเปลี่ยนสถานะ ชำระสำเร็จ ทั้งหมด</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-datas',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแสดงข้อมูลรายการจ่ายหนี้</Bold>
            <div>
              - ใบจ่ายหนี้ 1 ใบ เกิดจากการรับเข้าคลัง 1 ครั้ง หาก 1 ใบสั่งซื้อสินค้า รับเข้าคลังหลายรอบ
              จะเกิดใบจ่ายหนี้ ตามจำนวนการรับเข้าคลัง
            </div>
            <div>- หาก 1 ใบสั่งซื้อสินค้า รับเข้าคลังหลายรอบ จะเกิดใบจ่ายหนี้ ตามจำนวนการรับเข้าคลัง</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-no',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>เลขที่ใบจ่ายหนี้ (GRN) </Bold> กดที่เลขที่ใบจ่ายหนี้ เพื่อดูรายละเอียดใบจ่ายหนี้
            และชำระหนี้/ลดหนี้
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-payment-date',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>วันที่กำหนดชำระ </Bold> โดยเริ่มคิดจากวันที่ร้านค้าได้รับสินค้าจากผู้ขาย(Supplier)
            บวกเครดิตวันจ่ายหนี้ที่ Supplier กำหนดไว้ (ดูที่เมนู ระบบจัดซื้อ &gt; ข้อมูลบริษัท/Supplier)
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-status-data',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>สถานะของรายการจ่ายหนี้ </Bold> แบ่งเป็น 3 สถานะ ดังต่อไปนี้
            <div>
              <Bold>รอชำระหนี้ </Bold> คือรายการจัดซื้อ ที่รับเข้าคลังสำเร็จ
              แต่ร้านค้ายังไม่ได้ชำระเงินให้กับผู้ขาย (Supplier)
            </div>
            <div>
              <Bold>ชำระแล้วบางส่วน </Bold> คือรายการจ่ายหนี้ที่มีการชำระแล้ว แต่ยังชำระไม่เต็มจำนวน
            </div>
            <div>
              <Bold>ชำระสำเร็จ </Bold> คือรายการจ่ายหนี้ที่มีการชำระเงินให้กับผู้ขาย(Supplier) ครบแล้ว
            </div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
      {
        target: '.ttr-pagination',
        content: (
          <div style={{ textAlign: 'left' }}>
            <Bold>ส่วนของการแบ่งหน้ารายการจ่ายหนี้ </Bold>
            <div>
              - สามารถเปลี่ยนจำนวนรายการจ่ายหนี้ที่ต้องการแสดงผลต่อ 1 หน้า
              ได้ที่การเลือกจำนวนตัวเลขฝั่งซ้ายมือ
            </div>
            <div>- สามารถเลือกเลขหน้า เพื่อดูข้อมูลรายการจ่ายหนี้ในหน้าต่อๆไปได้</div>
          </div>
        ),
        locale,
        showProgress,
        hideBackButton,
      },
    ] as Step[],
  },
}
